import _default from './Rail';
export { _default as default };


//////////////////
// WEBPACK FOOTER
// ./~/semantic-ui-react/dist/es/elements/Rail/index.js
// module id = 957
// module chunks = 0